import React from 'react'
import PropTypes from 'prop-types'

import './styles.css'

const Banner = ({ title, subtitle, img }) => {
  const styles = {
    backgroundImage: `url(${img})`
  }

  return (
    <div className="banner d-flex justify-content-center align-items-center flex-column" style={styles}>
      <h1>{title}</h1>
      <h3>{subtitle}</h3>
    </div>
  )
}

Banner.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
}

export default Banner